import { useIntl } from "react-intl";
import { useWatch } from "react-hook-form";

import Select from "components/v2/Select/Select";
import { useReactiveReviewClear } from "@RequestFormV2/hooks/useReactiveReviewClear";
import type { DeliveryServiceLevelSlice } from "@RequestFormV2/sections/Schedule/hooks/useDeliveryServiceLevel";
import { getDeliveryServiceLevelOptions } from "@RequestFormV2/sections/Schedule/utils/deliveryServiceLevelOptions";

interface DeliveryServiceLevelFieldsProps {
  readonly deliveryServiceLevel: DeliveryServiceLevelSlice;
}

export default function DeliveryServiceLevelFields({ deliveryServiceLevel }: DeliveryServiceLevelFieldsProps) {
  const intl = useIntl();
  const serviceLevel = useWatch({ name: "service.service_level" }) as string | undefined;

  useReactiveReviewClear("service.service_level", () => Boolean(serviceLevel), [serviceLevel]);

  if (!deliveryServiceLevel.showServiceLevelSelect) return null;

  return (
    <div className="rfv2-schedule-service-level">
      <Select
        name="service.service_level"
        required
        label={intl.formatMessage({
          id: "new-request.service.serviceLevel",
          defaultMessage: "Service level",
        })}
        options={getDeliveryServiceLevelOptions(intl)}
        isClearable
        testId="request-form-schedule-delivery-service-level"
      />
    </div>
  );
}
